// extracted by mini-css-extract-plugin
module.exports = {"maskIcon":"_1xFdz9M","lightIcon":"_3r-eaAq _1xFdz9M","darkIcon":"_1Rm1RLy _1xFdz9M","blackIcon":"_3hosVfD _1xFdz9M","deleteItem":"_2y4LZqx","deleteItemIcon":"eFAEfpA _1xFdz9M"};